import { useEffect, useState } from 'react';
import { useDebouncedValue } from '../../../customHook/useDebouncedValue';

const Filter = ({ keyword, setKeyword, groupBy, setGroupBy }) => {

    // Typing updates the box instantly; the list only refetches once typing settles.
    const [searchText, setSearchText] = useState(keyword);
    const debouncedSearch = useDebouncedValue(searchText);

    useEffect(() => {
        if (debouncedSearch !== keyword) setKeyword(debouncedSearch);
    }, [debouncedSearch]);

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const handleGroupChange = (group) => {
        setGroupBy(group);
    };

    const handleClearSearch = () => {
        setSearchText('');
    };

    return (
        <div className="filter-paln">
            <div className="search-section-box">
                <form
                    className="app-search "
                    onSubmit={(e) => e.preventDefault()}
                >
                    <div className="position-relative">
                        <input
                            type="text"
                            className="form-control search-input-with-clear"
                            placeholder="Search Company/Project name..."
                            value={searchText}
                            onChange={handleSearchChange}
                        />
                        <span className="bx bx-search-alt" />
                        {searchText && (
                            <button
                                type="button"
                                className="search-clear-btn"
                                aria-label="Clear search"
                                title="Clear search"
                                onClick={handleClearSearch}
                            >
                                <i className="bx bx-x" />
                            </button>
                        )}
                    </div>
                </form>
            </div>
            <ul>
                <li>
                    <a href="javascript:void(0);"
                        onClick={() => handleGroupChange('none')}
                    >
                        <i
                            className="fa fa-list"
                            style={{ fontSize: groupBy === 'none' ? 19 : 15 }}
                        />{' '}
                        List
                    </a>
                </li>
                <li>
                    <a href="javascript:void(0);"
                        onClick={() => handleGroupChange('company')}
                    >
                        <i
                            className="fa fa-building"
                            style={{ fontSize: groupBy === 'company' ? 19 : 15 }}
                        />{' '}
                        By Company
                    </a>
                </li>
                <li>
                    <a href="javascript:void(0);"
                        onClick={() => handleGroupChange('shipyard')}
                    >
                        <i
                            className="bx bxs-ship"
                            style={{ fontSize: groupBy === 'shipyard' ? 19 : 15 }}
                        />{' '}
                        By Shipyard
                    </a>
                </li>

            </ul>
        </div>



    );
};

export default Filter;
